module.exports = __webpack_public_path__ + "static/img/access-denied.905d175.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/access-denied.svg
// module id = 5oKX
// module chunks = 0